export default __webpack_public_path__ + "static/media/tea_cup_level_01.d8165e91.webp";